// One value per (a, b) object pair, held by two WeakMaps: both keys can be
// collected, so nothing outlives the program or the catalog it was made from.
export function pairCache<A extends object, B extends object, V>(): (
  a: A,
  b: B,
  make: () => V,
) => V {
  const byA = new WeakMap<A, WeakMap<B, V>>();
  return (a, b, make) => {
    const byB = byA.get(a) ?? new WeakMap<B, V>();
    byA.set(a, byB);
    if (byB.has(b)) return byB.get(b) as V;
    const v = make();
    byB.set(b, v);
    return v;
  };
}
